import { HostBinding, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class RmaIntercomService {
  @HostBinding()
  class = 'intercom-web-bot'; // this class is defined in the global stylesheet
  public trackEvent(eventName: string, metadata?: object): void {
    if (!this.intercomIsLoaded) {
      return;
    }

    Intercom('trackEvent', eventName, metadata);
  }

  public openChatWithMessage(message: string): void {
    if (!this.intercomIsLoaded) {
      return;
    }

    Intercom('showNewMessage', message);
  }

  public startTour(tourId: number): void {
    if (!this.intercomIsLoaded) {
      throw new Error(`Intercom is not loaded, cannot start tourId ${tourId}`);
    }

    Intercom('startTour', tourId);
  }

  private get intercomIsLoaded(): boolean {
    return typeof Intercom !== 'undefined';
  }
}
